

export const localStorageConst = {
    LOCAL_STORAGE_ORDERLAH_DEVICE_ID: "ORDERLAH_DEVICE_ID",
    LOCAL_STORAGE_CURRENT_COUNTER_ID: "CURRENT_COUNTER_ID",
}

export const pinLoginConst = {
    PIN_MIN_DIGITS: 6,
    PIN_MAX_DIGITS: 12,
}